export default "__VITE_ASSET__78c30560__"